export const onRecaptchaReady = (props) => {
    return window.grecaptcha['enterprise'].ready(props)
}
export const getRecaptchaToken  = (props) => {
    return window.grecaptcha['enterprise'].execute(props)
}



// WEBPACK FOOTER //
// ./src/componentes/grecaptchaHelpers.js